import { render, staticRenderFns } from "./FrequentlyAskedQuestions.vue?vue&type=template&id=620748e6&scoped=true"
import script from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=ts"
export * from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=ts"
import style0 from "./FrequentlyAskedQuestions.vue?vue&type=style&index=0&id=620748e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620748e6",
  null
  
)

export default component.exports